import React from 'react';
import { QUOTE_TOKENS_BY_ID } from '../../constants/exchangeQuoteTokens';

/** “You receive” token icon + labels driven by the selected top-pair token. */
function QuoteTokenDisplay({ tokenId }) {
  const m = QUOTE_TOKENS_BY_ID[tokenId] ?? QUOTE_TOKENS_BY_ID.usdc;

  return (
    <>
      <div className="relative mr-2">
        <img
          alt={m.label}
          className="border border-[#393941] rounded-full"
          decoding="async"
          height="32"
          src={m.tokenSrc}
          width="32"
        />
        <div className="absolute -bottom-1 -right-1">
          <img
            alt={m.chainName}
            className="border border-[#393941] rounded-full"
            decoding="async"
            height="16"
            src={m.chainSrc}
            width="16"
          />
        </div>
      </div>
      <div className="flex flex-col items-start md:mr-2">
        <span className="text-[#F7F7F8] font-medium text-base">{m.symbol}</span>
        <span className="text-[#9091A0] text-xs md:block hidden">{m.chainName}</span>
      </div>
    </>
  );
}

export default QuoteTokenDisplay;
